import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

import breakpoints from '../utils/breakpoints';
import {
  disableFocusOnHiddenSlides,
  getGenericSliderConfig
} from '../utils/slider';

const fullWidthModuleConfig = {
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 0
};

const reducedWidthModuleConfig = {
  slideToClickedSlide: false,
  slidesPerView: 1,
  spaceBetween: 0
};

class Testimonials extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el._$('h2'),
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container')
    };

    this.initSlider();
    this.updateFocusableElements();
  }

  initSlider() {
    const { $swiperContainer, $heading } = this.dom;

    const moduleConfigLg = this.el.closest('.big-wrapper')
      ? reducedWidthModuleConfig
      : fullWidthModuleConfig;

    const element = this.el;

    this.swiper = new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, $heading),
      slidesPerView: 1,
      spaceBetween: 25,
      breakpoints: {
        [breakpoints.tablet]: {
          slideToClickedSlide: false,
          slidesPerView: 1,
          spaceBetween: 40,
          centeredSlides: true
        },
        [breakpoints.lg]: moduleConfigLg
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        }
      }
    });
  }
  updateFocusableElements() {
    const { $slides } = this.dom;
    if (!this.swiper) return;
    this.swiper.on('slideChangeTransitionStart', () =>
      disableFocusOnHiddenSlides($slides)
    );
    disableFocusOnHiddenSlides($slides);
  }
}

export default Testimonials;
